import { render } from "./DragDropMultiFileUpload.vue?vue&type=template&id=31ea426d&scoped=true"
import script from "./DragDropMultiFileUpload.vue?vue&type=script&lang=js"
export * from "./DragDropMultiFileUpload.vue?vue&type=script&lang=js"

import "./DragDropMultiFileUpload.vue?vue&type=style&index=0&id=31ea426d&scoped=true&lang=css"

import exportComponent from "/home/bazyaarc/sources/bazyaar-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ea426d"]])

export default __exports__